import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _moment from 'moment';
import { Observable, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { CreateApplicationRequest, CreateApplicationResponse, PaymentConfig, Person, PolicyObject } from '../shared/insurance.model';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json-patch+json',
    'x-api-version': '2.0'
  })
};

@Injectable({
  providedIn: 'root'
})
export class TravelService {
  setPolicyMetadataSubscription: Subscription;
  getTokenSubscription: Subscription;


  dataItem: any = {};
 token : string;

 appresult : CreateApplicationResponse;

  responseTypes = [
    {
      id: 1,
      product: 'standart',
      currency: 'USD',
      currencySymbol: '$'
    },
    {
      id: 2,
      product: 'comfort',
      currency: 'USD',
      currencySymbol: '$'
    },
    {
      id: 3,
      product: 'premium',
      currency: 'USD',
      currencySymbol: '$'
    },
    {
      id: 4,
      product: 'standart',
      currency: 'EUR',
      currencySymbol: '€'
    },
    {
      id: 5,
      product: 'comfort',
      currency: 'EUR',
      currencySymbol: '€'
    },
    {
      id: 6,
      product: 'premium',
      currency: 'EUR',
      currencySymbol: '€'
    },
  ]

  readonly API_SERVER = 'https://platformapi.aldagi.ge';

  constructor(private http: HttpClient) {  }

  calculatePremiums(formData): Observable<any> {
    return this.http.post(this.API_SERVER + '/api/Calculate/premiums-for-travel', formData, httpOptions);
  }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  getAuthToken(): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('grant_type', 'client_credentials');
    formData.append('client_id', 'onlinetravel');
    formData.append('client_secret', 'bfpw3jWPaj');
    return this.http
      .post('https://identity.aldagi.ge/' + 'connect/token', formData)
      .pipe(map(this.extractData));
  }

  public getToken(): string {
    return JSON.parse(localStorage.getItem('token'));
  }


  get data(): any {
    return JSON.parse(localStorage.getItem('calculate'));
  }

  get result(): any {
    return JSON.parse(localStorage.getItem('policy'));
  }

  get createApplicationResponse(): CreateApplicationResponse {
     return JSON.parse(localStorage.getItem('policyDraft'));
  }

  set createApplicationResponse(response: CreateApplicationResponse) {
    const policyDraft = JSON.stringify({...response, token: this.getToken()});
    localStorage.clear();

    localStorage.setItem('policyDraft', policyDraft);
  }

  sendPaymentRequest(paymentRequestConfig: PaymentConfig): void {
    const paymentLink =
    paymentRequestConfig.PAY_URL +
            '&o.applicationId=' +
            this.createApplicationResponse.policyApplicationId +
            '&back_url_f=' +
            paymentRequestConfig.BASE_URL +
            '/confirm' +
            '&back_url_s=' +
            paymentRequestConfig.BASE_URL +
            '/success/' +
            this.createApplicationResponse.policyApplicationId;

    window.location.href = paymentLink;
  }

  getPolicyPrintForm(id : number) {

    this.getAuthToken().subscribe((token: any) => {
      this.token = token.access_token;

    });
      const headers = {
        'X-Content-Language': 'en',
        Authorization: `Bearer ${this.token}`
      };

    return this.http.get(this.API_SERVER + '/api/Documents/' + id,
      {
        responseType: 'blob' as 'json',
        headers: {
          'X-Content-Language': 'en',
          Authorization: `Bearer ${this.token}`
        }
      });
  }

  cookCreateApplicationRequest(): CreateApplicationRequest {
    const policy: PolicyObject = this.result;
    const request = this.convertPolicyObjectToCreateApplicationRequest(policy);

    return request;
  }

  private convertPolicyObjectToCreateApplicationRequest(policy: PolicyObject ): CreateApplicationRequest {
    const currency: string = JSON.parse(localStorage.getItem('insurance')).currency;
    const policyType: string = policy.PolicyType.policy;
    const productId = this.responseTypes.find(rt => rt.currencySymbol === currency && rt.product === policyType).id;

    const request: CreateApplicationRequest = new CreateApplicationRequest();
    request.insurer = new Person();
    request.insurer.dateOfBirth =  this.removeTimePart(new Date(policy.PersonalInfo.birthDate));
    request.insurer.firstName = policy.PersonalInfo.name;
    request.insurer.lastName = policy.PersonalInfo.surname;
    request.insurer.personalId = policy.PersonalInfo.personalNumber;
    request.insurer.email = policy.ContactInfo.email;
    request.insurer.phone = policy.ContactInfo.phone;
    request.productId = productId;
    request.withCovid = policy.PolicyType.covid;
    request.travelFranchiseTypeId = policy.PolicyType.franchise ? 1 :  2;
    request.countryIds = ['dadbbad9-0598-4a8f-b790-32b4a0e87642'];

    if (policy.InsurancePeriod) {
      request.startDate = this.getCorrectStartDate(new Date(policy.InsurancePeriod.startDate));
      request.endDate  = this.removeTimePart(new Date(policy.InsurancePeriod.endDate));
    }
    if (policy.InsuranceDays) {
      request.travelPeriodInDays = policy.InsuranceDays.days;
    }

    request.travelTypeId = policy.InsuranceType.type === 'once' ? 1 : 2;

    request.travellers = [];
    request.travellers.push({...request.insurer});

    if (policy.PassengerInfo) {

      policy.PassengerInfo.forEach(passenger => {
        const person: Person = new Person();
        person.dateOfBirth = this.removeTimePart(new Date(passenger.birthDate));
        person.firstName =  passenger.name;
        person.lastName =  passenger.surname;
        person.personalId = passenger.personalNumber;

        request.travellers.push(person);
      });
    }

    return request;
  }

  calculateAgain() {
    this.calculatePremiums(this.data).subscribe(
      (res: any) => {
        const result = res.filter(o1 => this.responseTypes.some(o2 =>
          o1.travelProductId === o2.id && o2.product === this.result.PolicyType.policy));
        this.dataItem = result[0].premium;
      },
      err => {

      }
    );
  }

  getCorrectStartDate(dateToCorrect: Date): Date {
    const currentDate = new Date(Date.now());

    if (currentDate.getDate() === dateToCorrect.getDate() &&
    currentDate.getMonth() === dateToCorrect.getMonth() &&
    currentDate.getFullYear() === dateToCorrect.getFullYear()) {
      return dateToCorrect;
    }

    return this.removeTimePart(dateToCorrect);
  }

  removeTimePart(dateToChange: Date): Date {
    return new Date(dateToChange.toDateString());
  }

  addDays(date: Date, days: number) {
    date.setDate(date.getDate() + days);
    return date;
  }
}


